import React from "react";
import "./GoToButton.css";

const GoToButton = () => (
  <div>
    <button className="dots-map__go-to-button" onClick={() => {}}>
      <span>&rarr;</span>
    </button>
  </div>
);

export default GoToButton;
